import { API_BASE_URL, APP_NAME } from './env.config';

export const env = {
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  apiBaseUrl: API_BASE_URL,
  appName: APP_NAME,
};
